import { render } from "./InventoryIndex.vue?vue&type=template&id=4132338f&scoped=true"
import script from "./InventoryIndex.vue?vue&type=script&lang=js"
export * from "./InventoryIndex.vue?vue&type=script&lang=js"

import "./InventoryIndex.vue?vue&type=style&index=0&id=4132338f&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4132338f"]])

export default __exports__